import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { select, Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { ClipboardService } from 'ngx-clipboard';
import { map, Subject, takeUntil } from 'rxjs';
import { AffiliationProfile } from '../../../../taxation/models/affiliation.model';
import {
  enableAffiliationProfileAction,
  loadAffiliationProfileAction,
} from '../../../../taxation/store/actions/affiliation.action';
import * as fromAffiliation from '../../../../taxation/store/selectors/affiliation.selector';
import { UtilsService } from '../../../services/utils.service';

@Component({
  selector: `app-referral-dialog`,
  standalone: true,
  imports: [CommonModule, TranslateModule, MatButtonModule],
  templateUrl: `./referral-dialog.component.html`,
  styleUrl: `./referral-dialog.component.scss`,
})
export class ReferralDialogComponent implements OnInit {
  affiliationProfile: AffiliationProfile;
  referralCode = ``;

  copied = false;

  private readonly destroy$: Subject<void> = new Subject<void>();

  constructor(
    private readonly affiliationStore$: Store<fromAffiliation.State>,
    private readonly clipboardService: ClipboardService,
    private readonly utilsService: UtilsService,
  ) {}

  ngOnInit(): void {
    this.affiliationStore$
      .pipe(
        takeUntil(this.destroy$),
        select(fromAffiliation.selectAffiliationProfile),
        map((affiliationProfile: AffiliationProfile) => {
          this.affiliationProfile = affiliationProfile;

          if (!affiliationProfile) {
            this.affiliationStore$.dispatch(loadAffiliationProfileAction());
          } else if (!affiliationProfile.enabled) {
            this.affiliationStore$.dispatch(enableAffiliationProfileAction());
          } else {
            this.referralCode = affiliationProfile.affiliateId;
          }
        }),
      )
      .subscribe();
  }

  copySponsorshipCode(): void {
    this.clipboardService.copyFromContent(this.utilsService.getReferralContent(this.referralCode));
    this.copied = true;
  }

  openSocialNetworkLink(media: string): void {
    this.utilsService.openSocialNetworkLink(media, this.referralCode);
  }
}
